import AdUnit from "../../core/AdUnit";
import LibLoader from "../../utils/LibLoader";

import { AdUnitStatus, AdvIDPrefix, event, GNEZDO_URL } from "../../utils/const";
import { getRandomString } from "../../utils/utils";

export default class Gnezdo extends AdUnit {
  constructor(cfg) {
    super(cfg);

    this.state = {
      success: false,
    }

    this.init();
  }

  init = () => {
    if (!window.gnezdoAsyncCallbacks) {
      return LibLoader.load(GNEZDO_URL,
        () => { this.init(); },
        () => {
          this.logger.log('[Gnezdo] error during load library');
          this.localEmitter.emit(event.Ad.AdError, { code: 9 });
        }
      );
    }

    this.logger.log(`[Gnezdo - ${this.config.params.tid}] init() called`);

    this.advID = AdvIDPrefix.GNEZDO + getRandomString();
    this.slot.id = this.advID;

    this.status = AdUnitStatus.LOADED;
  }

  start() {
    this.logger.log(`[Gnezdo - ${this.config.params.tid}] start() called`);

    const { template } = this.config;
    const { slot } = JSON.parse(template);

    this.timers.startAd = setTimeout(() => {
      this.logger.log(`[Gnezdo - ${this.config.playerConfig.zone} / ${this.config.params.tid}] startAd timeout`);
      this.localEmitter.emit(event.Ad.AdError, { code: 2 });
    }, this.config.timeouts.yartbstart || 5000);

    window.gnezdoAsyncCallbacks.push(() => {
      gnezdo.create({
        tizerId: slot,
        containerId: this.advID,
        // onLoad: (block) => {},
        onSuccess: (block) => {
          this.state.success = true;
        },
        onStub: (block) => {
          this.localEmitter.emit(event.Ad.AdError, { code: 1 });
        },
        onEmpty: (block) => {
          this.localEmitter.emit(event.Ad.AdError, { code: 1 });
        },
        onRender: (block) => {
          if (this.state.success) {
            this.localEmitter.emit(event.Ad.AdVideoStart);
            this.localEmitter.emit(event.Ad.AdImpression);
          }

          this.timers.bannerShow = setTimeout(() => {
            this.localEmitter.emit(event.Ad.AdVideoComplete);
          }, this.config.timeouts.gnezdo || 15000);
        },
      });
    })
  }
}
